var _effectorFileName = "/builds/gmini/front-utils/src/hexToRgba.ts";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.concat.js";
export var hexToRgba = function hexToRgba(hex, opacity) {
  var hexCode = hex.replace('#', '');

  if (hexCode.length === 3) {
    hexCode = hexCode.split('').map(function (_char) {
      return _char + _char;
    }).join('');
  }

  var r = parseInt(hexCode.substring(0, 2), 16);
  var g = parseInt(hexCode.substring(2, 4), 16);
  var b = parseInt(hexCode.substring(4, 6), 16);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};